import * as React from 'react';
import { ButtonPrimary, ButtonSecondary, Textarea } from 'ui';
import { MainLanguageProps, SecondaryTextMode } from '../types';
import { SHORT_DEBOUNCE_TIME } from '../constants';
import styles from './main-language.scss';

export class MainLanguage extends React.Component<MainLanguageProps> {

  private onPrimaryTextChange = (value: string) => {
    const { onPrimaryTextChange, mainLanguage } = this.props;
    onPrimaryTextChange(mainLanguage, value);
  };

  private onSecondaryTextChange = (value: string) => {
    const { onSecondaryTextChange, mainLanguage } = this.props;
    onSecondaryTextChange(mainLanguage, value);
  };

  public render() {
    const {
      primaryText, secondaryText, primaryTextMaxLength, secondaryTextMaxLength,
      secondaryTextMode, readOnly, displayCopyToAll,
      copyPrimaryTextToAllTranslations, copySecondaryTextToAllTranslations,
      primaryTextValidation, secondaryTextValidation,
      primaryTextLabel, secondaryTextLabel, secondaryTextInfo,
      copyPrimaryTextToAllLabel, copySecondaryTextToAllLabel
    } = this.props;

    const displayPrimaryCopyToAll = !readOnly && displayCopyToAll;
    const displaySecondaryCopyToAll = displayPrimaryCopyToAll && secondaryTextMode !== SecondaryTextMode.readOnly;

    return <div className={styles.mainLanguage}>
      <div className={styles.mainLanguageContainer}>
        <div className={`${displayPrimaryCopyToAll ?
          styles.mainLanguageInput :
          styles.mainLanguageInputWide} ${styles.mainLanguageInputWrapper}`}>
          <Textarea
            componentId="main_language_primary_text"
            className={'mb-0'}
            label={{ text: primaryTextLabel, additionalText: this.props.mainLanguageDescription, required: !readOnly }}
            value={primaryText}
            onChange={this.onPrimaryTextChange}
            readOnly={readOnly}
            maxLength={primaryTextMaxLength}
            wait={SHORT_DEBOUNCE_TIME}
            validation={primaryTextValidation} />
        </div>
        {displayPrimaryCopyToAll && <div className={styles.mainLanguageButtonContainer}>
          <ButtonPrimary
            id="copy_primary_text_to_all_translations"
            onClick={copyPrimaryTextToAllTranslations}
            classNames={styles.mainLanguageButton}>
            {copyPrimaryTextToAllLabel}
          </ButtonPrimary>
        </div>}
      </div>
      {secondaryTextMode !== SecondaryTextMode.disabled &&
        <div className={styles.mainLanguageContainer}>
          <div className={`${displayPrimaryCopyToAll ? styles.mainLanguageInput :
            styles.mainLanguageInputWide} ${styles.mainLanguageInputWrapper}`}>
            <Textarea
              componentId="main_language_secondary_text"
              className={'mb-0'}
              label={{
                text: secondaryTextLabel,
                required: (!readOnly && secondaryTextMode === SecondaryTextMode.required) || !!secondaryTextInfo
              }}
              info={{ text: secondaryTextInfo, visible: !!secondaryTextInfo }}
              value={secondaryText}
              onChange={this.onSecondaryTextChange}
              readOnly={readOnly || secondaryTextMode === SecondaryTextMode.readOnly}
              maxLength={secondaryTextMaxLength}
              wait={SHORT_DEBOUNCE_TIME}
              validation={secondaryTextValidation} />
          </div>
          {displaySecondaryCopyToAll && <div className={styles.mainLanguageButtonContainer}>
            <ButtonSecondary
              id="copy_secondary_text_to_all_translations"
              onClick={copySecondaryTextToAllTranslations}
              classNames={styles.mainLanguageButton}>
              {copySecondaryTextToAllLabel}
            </ButtonSecondary>
          </div>}
        </div>}
    </div>;
  }
}
